/* Navigation Paths for the entire application */
export enum PATH {
  EMPTY = '',
  NOT_FOUND = 'not-found',
  NO_ACCESS = 'no-access',
  ACCESS_LEVEL = 'access-level',
  AUTH = 'auth',
  AUTH_ERROR = 'authentication-error',
  ROOT = 'root',
  HOME = 'home',
  CUSTOMER = 'customer',
  ID = ':id',
  COUNTRY = ':country',
  RESUME = 'resume',
  WIDGETS = 'widgets',
  ONBOARDING = 'onboarding',
  CREDIT = 'credit',  
  ACCOUNT = 'account',
  ORDERS = 'orders',
  CALLS = 'calls',
  NOTIFICATIONS = 'notifications',
  BILL_PAYMENTS = 'bill-payments',
  CLARIFICATION = 'clarification',
  TEAM = 'team',
  BUSINESS = 'business',
  INSTALLMENTS_LOANS = 'prestamos',
  INSURANCE = 'insurance',
}
